import { render, staticRenderFns } from "./DashboardFaceMatch.vue?vue&type=template&id=36b0e8d4"
import script from "./DashboardFaceMatch.vue?vue&type=script&lang=js"
export * from "./DashboardFaceMatch.vue?vue&type=script&lang=js"
import style0 from "./DashboardFaceMatch.vue?vue&type=style&index=0&id=36b0e8d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports